import SignIn from "../../components/Auth/SignIn";

const SignInPage = () => { 
    return <SignIn /> 
}; 

export default SignInPage;